import { connect as react_redux_connect } from 'react-redux';
const emptyDispatch = action => action;

// This is a shim to expose the same interface as `react-redux`'s connect() to
// make the transition easier.
const connect = function(
    mapStateToProps,
    mapDispatchToProps = {},
    mergeProps,
    options = {}
) {
    // Loader expects dispatch to be included in `props`
    mapDispatchToProps.dispatch = emptyDispatch;
    return react_redux_connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps,
        options
    );
};

export default connect;



// WEBPACK FOOTER //
// ./src/components/connect.js